import React from 'react';
import CIcon from '@coreui/icons-react';
import { cilMoon, cilSun } from '@coreui/icons';
import { useTheme } from '../../hooks/useTheme';

// Botón de icono para la barra superior (estilo Medusa)
export const ThemeToggle = () => {
    const { theme, toggleTheme } = useTheme();
    const label = theme === 'light' ? 'Modo oscuro' : 'Modo claro';

    return (
        <button type="button" className="btn md-icon-button" onClick={toggleTheme} title={label} aria-label={label}>
            <CIcon icon={theme === 'light' ? cilMoon : cilSun} />
        </button>
    );
};
